export default function TermsOfUse() {
  return (
    <div className="privacy-maincard">
      <div style={{ padding: "20px" }}>
        <div className="privacy-maintitle">
          <h1>Terms of Use</h1>
          <p>
            By accessing LEGITIMATELY, you agree to adhere to our terms and
            conditions outlined below.
          </p>
          <div className="privacy_cards">
            <div className="privacy_title">
              <h2>Acceptance of Terms</h2>
              <p>
                Using LEGITIMATELY implies your consent to follow our rules and
                policies.
              </p>
            </div>
            <div className="privacy_title">
              <h2>Prohibited Activities</h2>
              <p>
                Users must refrain from activities that violate local or
                international laws.
              </p>
            </div>
            <div className="privacy_title">
              <h2>Amendments</h2>
              <p>
                LEGITIMATELY reserves the right to modify these terms at any
                time.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
